/* Scope discovery only in this draft theme; product URLs and checkout are unchanged. */
(() => {
  const prefix = 'tag:"naturise-ch-shop" AND (';
  const isScoped = (q) => q.startsWith(prefix) && q.endsWith(')');
  const scope = (url) => {
    const q = (url.searchParams.get('q') || '').trim();
    if (!q) return url;
    if (!isScoped(q)) url.searchParams.set('q', prefix + q + ')');
    url.searchParams.set('type', 'product');
    return url;
  };
  const isSearch = (url) => url.origin === location.origin && url.pathname.split('/').filter(Boolean).pop() === 'search';
  const current = new URL(location.href);
  if (isSearch(current) && current.searchParams.get('q')) {
    const scoped = scope(new URL(current));
    if (scoped.href !== current.href) {
      location.replace(scoped.href);
      return;
    }
  }
  document.addEventListener('submit', (event) => {
    if (event.defaultPrevented || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    const url = new URL(form.action, location.href);
    if (!isSearch(url) || !form.querySelector('input[type="search"]')) return;
    const data = new FormData(form);
    if (!String(data.get('q') || '').trim()) return;
    event.preventDefault();
    for (const [key, value] of data) url.searchParams.set(key, String(value));
    url.searchParams.delete('page');
    location.assign(scope(url).href);
  });
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (!link || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (!isSearch(url) || !url.searchParams.get('q')) return;
    const scoped = scope(new URL(url));
    if (scoped.href !== url.href) {
      event.preventDefault();
      location.assign(scoped.href);
    }
  });
})();
